import GenericPage from '../components/generic/GenericPage'
import tiles from '../components/generic/Tiles'

const MapDD = () => {
  return (
    <GenericPage frame="https://rsgiskaznu.maps.arcgis.com/apps/mapviewer/index.html?webmap=e196c3af05dc45a5a51e9eabe9db7cf8" title="Карта степени деградации" tiles={tiles.back('map')} frame_offset={60}/>
  )
}
export default MapDD
